import { FilterHandlerBase } from './base/filter-handler-base';
import { AdvancedFilterName, FilterPassParams } from '../filter-types';
import { FilterResultFacade } from '../filter-result-facade';
import { isInstanceOfInclusiveExclusiveFilterModel } from '../filter-utils';

export class OfferingTypeAdvancedFilterHandler extends FilterHandlerBase {
  get name(): string {
    return AdvancedFilterName.offeringType;
  }

  doFilterPass(params: FilterPassParams, result: FilterResultFacade) {
    const offeringType = params.filters[this.name];
    const data = params.deal;
    const filterModel = offeringType.model;
    const offeringTypeFilterPassed = isInstanceOfInclusiveExclusiveFilterModel(
      filterModel
    )
      ? filterModel.storeValues?.indexOf(data.dealType) !== -1
      : data.dealType === filterModel.value;
    result.applyDealFilerResult(data.id, this.name, offeringTypeFilterPassed);

    return offeringTypeFilterPassed;
  }
}
